import * as Backbone from "backbone";
import * as _ from "lodash";
import { PermissionCollection } from "../collections/Permissions";
import { BaseCollection } from "../collections/_BaseCollection";
import { BaseInternalView, BaseInternalViewOptions } from "./_BaseViews";

export interface BaseListOptions extends BaseInternalViewOptions {
    groupPermissionCollection?: PermissionCollection;
}

export interface ColumnProperties {
    attribute?: string,
    columnUrl?: string,
    centerColumn?: boolean,
    isPermissionsColumn?: boolean,
    columnIndex?: number,
    // When using a custom column with a collection,
    // refer to the model being iterated over as `mod` (e.g. `mod.get('attribute'))
    customColumn?: {
        templateFunction: Function,
        variables?: any
    },
    permissionFunctionGroup?: any,
    permissionFunction?: any,
    permissionInfo?: {
        permissionInfoClass: string,
        info: string,
    },
    columnSizes: {
        'lg'?: string,
        'md'?: string,
        'sm'?: string,
        'xs'?: string
    },
}

export interface TableProperties {
    name?: string,
    columnProperties: { [columnName: string]: ColumnProperties },
    canDeletePermissionFunction?: any,
    canDeletePermissionFunctionAttribute?: string,
    canEditPermissions?: boolean,
    dataPermissionType?: string,
    rowUrl?: string,
    rowUrlAttribute?: string,
    limitedRows?: {
        count: number,
        collectionProperties: any,
        sortBy: string,
        reverseSort: boolean,
    },
    tableEmptyText?: string,
    tableWidth?: string,
    footer?: {
        url: string,
        text: string
    }
}

export class BaseList extends BaseInternalView {
    options: BaseListOptions;

    private collectionListTemplate = _.template(require('templates/account/listCollection.html'));

    protected defaultProperties: TableProperties = {
        columnProperties: {},
        tableWidth: 'col-md-12 col-sm-12 col-xs-12'
    };

    constructor(options: BaseListOptions) {
        super(<any>_.extend({}, options, {
            tagName: 'div',
        }));
    }

    renderCollectionList(collection: BaseCollection<Backbone.Model>, properties: TableProperties) {
        this.$el.html(this.collectionListTemplate({
            collection: collection,
            properties: _.extend({}, this.defaultProperties, properties)
        }));
        (<any> this.$('[data-toggle="tooltip"]')).tooltip();
        return this;
    }

    render() {
        return this;
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/_BaseList.ts